<div class="flex flex-row gap-2 align-items-center">
  @if (customIcon) {
    <sps-custom-icon [name]="icon" [alt]="text"></sps-custom-icon>
    <span>{{ text }}</span>
  } @else {
    <i [ngClass]="icon"></i>
    <span>{{ text }}</span>
  }
</div>
